import React, { Component } from "react";
import lockIcon from "../../../assets/images/seo-lock-icon.svg";
import barGraphIcon from "../../../assets/images/seo-bar-chart-icon.svg";
import searchIcon from "../../../assets/images/seo-search-icon.svg";
import "../../../styles/pages/seo/SEOFacts.css";

export default class SEOFacts extends Component {
  render() {
    return (
      <div className="SEOFacts gutters">
        <div className="section on-scroll-anim">
          <img src={lockIcon} alt="Lock icon." />
          <div className="g-sub-title">NO LOCKED IN CONTRACTS</div>
          <div className="g-sub-text">
            Our services speak for themselves. We don’t lock anyone into
            contracts because we believe our work will keep you coming back.
          </div>
        </div>

        <div className="section on-scroll-anim">
          <img src={searchIcon} alt="Search icon." />
          <div className="g-sub-title">MODERN SEO STANDARDS</div>
          <div className="g-sub-text">
            The game has changed. We use methods that work today, and make it a
            priority to stay up-to-date with the ever changing search
            algorithms.
          </div>
        </div>

        <div className="section on-scroll-anim">
          <img src={barGraphIcon} alt="Bar graph icon." />
          <div className="g-sub-title">MONTHLY REPORTS</div>
          <div className="g-sub-text">
            We are completely transparent with our clients. Each month we
            provide a status report on your site’s performance.
          </div>
        </div>
      </div>
    );
  }
}
